import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { useNavigate } from "react-router-dom";

import { captureException } from "util/exception";
import Button from "common/core/button";
import { useMutation } from "util/graphql";
import { useLogout } from "common/authentication";
import LeaveMeetingMutation from "common/meeting/sidebar/leave_meeting_mutation.graphql";

function LeaveMeeting({ meetingParticipant }) {
  const leaveMeetingMutateFn = useMutation(LeaveMeetingMutation);
  const navigate = useNavigate();
  const logout = useLogout();
  const leaveMeeting = () => {
    const input = { meetingParticipantId: meetingParticipant.id };

    return leaveMeetingMutateFn({ variables: { input } })
      .catch(captureException)
      .finally(() => {
        if (meetingParticipant.__typename === "CredibleWitnessParticipant") {
          logout().then(() => navigate("/"));
        } else {
          navigate("/");
        }
      });
  };

  return (
    <Button
      className="leave-meeting-button"
      buttonColor="danger"
      variant="primary"
      buttonSize="condensed"
      onClick={leaveMeeting}
      automationId="leave-meeting-button"
    >
      <FormattedMessage id="5789760d-f2d1-4db4-9043-39f02211ff96" defaultMessage="Leave meeting" />
    </Button>
  );
}

LeaveMeeting.propTypes = {
  meetingParticipant: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }),
};

export default LeaveMeeting;
